module.exports = __webpack_public_path__ + "media/site_templates/www.waterleakrepair.com.au/images/splash-4ea42ac20a7b0244633e4a4479612a58.jpg";